import { createRoot } from 'react-dom/client';
import NuiAdminConsole from './nuiAdminConsole';

const rootElement = createRoot(document.getElementById('root'));
rootElement.render(<NuiAdminConsole/>);
